import {
  YbCoreAccordion,
  YbCoreAccordionProps,
} from '@yubi/yb-core-accordion-v3';

function AccordionViewV3(props: YbCoreAccordionProps) {
  return <YbCoreAccordion {...props} />;
}

export default AccordionViewV3;
